import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function CopyToFirmsDialog({ open, onOpenChange, ids, onDone }) {
  const [targets, setTargets] = useState([]);
  const [sel, setSel] = useState([]);
  const [byIl, setByIl] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setSel([]); setByIl(false); api.get("/customers-copy/targets").then((r) => setTargets(r.data)).catch((e) => { toast.error(e.response?.data?.detail || "HATA"); onOpenChange(false); }); } }, [open, onOpenChange]);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.post("/customers-copy", { data: { ids, targets: sel, by_il: byIl } });
      Object.entries(r.data).forEach(([n, x]) => toast.success(`${n}: ${x.eklenen} EKLENDİ${x.guncellenen ? `, ${x.guncellenen} GÜNCELLENDİ` : ""}${x.atlanan ? `, ${x.atlanan} ZATEN VAR (ATLANDI)` : ""}`));
      onOpenChange(false); onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
    setBusy(false);
  };
  const label = byIl ? (sel.length ? `İLE GÖRE + ${sel.length} FİRMAYA AKTAR` : "İLE GÖRE AKTAR") : `${sel.length} FİRMAYA AKTAR`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader><DialogTitle>{ids.length} MÜŞTERİYİ FİRMAYA AKTAR</DialogTitle></DialogHeader>
        <p className="text-[11px] text-slate-400">MÜŞTERİ ANA DEPO'DA KALIR; HESAPLAMA, NOTLAR VE TÜM BİLGİLERİYLE KOPYALANIR. DAHA ÖNCE AKTARILMIŞSA GÜNCELLENİR.</p>
        <label className="flex items-start gap-2 rounded border border-sky-800 bg-sky-950/40 px-2 py-1.5 text-xs font-bold text-sky-200">
          <input data-testid="copy-by-il" type="checkbox" checked={byIl} onChange={(e) => setByIl(e.target.checked)} className="mt-0.5" />
          <span>İLE GÖRE OTOMATİK: HER MÜŞTERİ KENDİ İLİNE HİZMET VEREN FİRMA(LAR)A GİDER<span className="block font-normal text-sky-300/70">AŞAĞIDAN SEÇTİĞİNİZ FİRMALARA DA AYRICA GÖNDERİLİR</span></span>
        </label>
        <label className="flex items-center gap-2 text-xs font-bold"><input data-testid="copy-all-firms" type="checkbox" checked={sel.length === targets.length && targets.length > 0} onChange={(e) => setSel(e.target.checked ? targets.map((t) => t.id) : [])} /> TÜM FİRMALAR</label>
        <div className="max-h-72 space-y-1 overflow-auto">
          {targets.map((t) => (
            <label key={t.id} className="flex items-center gap-2 rounded border border-slate-800 px-2 py-1.5 text-sm">
              <input data-testid={`copy-firm-${t.id}`} type="checkbox" checked={sel.includes(t.id)} onChange={(e) => setSel((s) => (e.target.checked ? [...s, t.id] : s.filter((x) => x !== t.id)))} />
              <span className="flex-1">{t.name}</span>
              {t.iller?.length > 0 && <span className="truncate text-[10px] text-slate-400" title={t.iller.join(", ")}>{t.iller.slice(0, 4).join(", ")}{t.iller.length > 4 ? ` +${t.iller.length - 4}` : ""}</span>}
            </label>
          ))}
        </div>
        <Button data-testid="copy-submit" disabled={(!sel.length && !byIl) || busy} onClick={go} className="bg-emerald-600 text-white hover:bg-emerald-700">{busy ? "AKTARILIYOR..." : label}</Button>
      </DialogContent>
    </Dialog>
  );
}
